
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import "vue-loading-overlay/dist/vue-loading.css";
import {mapGetters, mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "FormCreateStartupInfo",
  props: {
    // esoProgram: { type: Object, default: {} },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState("user", ["currentUser"]),

    fullName() {
      const first_name = this.currentUser.first_name || "";
      const last_name = this.currentUser.last_name || "";
      return [first_name, last_name].join(" ").trim() || "-";
    },
    modalLabel() {
      return this.$t("update_profile");
      return this.esoProgram.product.id
          ? "Update Startup Profile"
          : "Add New Startup Profile";
    },
  },
  mounted() {


  },
  created() {
  },

  data() {
    return {
      profileImage: null,
      esoProgram: {}, // for loading profile into the view
      startup: {},
      fullPage: true,
      value: [],
      options: [],
      dialog: false,
      tabs: null,
      imageName: "",
      imageUrl: "",
      imageFile: "",
      editedItem: {}, // For compare phone and email edits
    };
  },
  async fetch() {
  },
  methods: {
    ...mapActions("eso-program", {
      editProgram : 'update',
      getProgram: 'get'
    }),
    openForm(item) {
      this.dialog = true;
      this.esoProgram = this.$common.cloneJSON(item);
      this.imageUrl = this.esoProgram.logo;
      this.editedItem = this.$common.cloneJSON(item);
      this.dialog = true;
    },

    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].size > 1000000) {
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });
          Toast.fire(this.$t("msg.failed"), "File size must be below 1MB", "error");

          return;
        }
        this.imageName = files[0].name;

        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }


        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {

          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });

      } else {

        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    saveForm() {
      this.saveBasicInfo();
    },
    closeForm() {
      this.dialog = false;
    },
    saveBasicInfo() {
      let valid = this.$refs.formProgramInfo.validate();
      if (!valid) return;
      this.sweetAlertLoading()
      const formData = new FormData(document.getElementById("formProgramInfo"));
      formData.append("eso", this.$route.params.esoId)
      formData.append("name", this.esoProgram.name)
      formData.append("description", this.esoProgram.description)

      formData.append("website_url", this.esoProgram.website_url|| '')
      formData.append("telegram_social_url", this.esoProgram.telegram_social_url|| '')
      formData.append("x_social_url", this.esoProgram.x_social_url|| '')
      formData.append("youtube_social_url", this.esoProgram.youtube_social_url|| '')
      formData.append("linkedin_social_url", this.esoProgram.linkedin_social_url|| '')
      formData.append("facebook_social_url", this.esoProgram.facebook_social_url|| '')

      this.editProgram({payload: formData, id: this.esoProgram.id})
          .then((res) => {
            this.sweetAlertLoadingClose()

            this.$swal.fire(
                `${this.$t("get_listed.dialog.title.success")}!`,
                `${this.$t("get_listed.dialog.title.success.message")}`,
                "success"
            );
            this.$emit("saved-update");
            this.getProgram({params: {eso: this.esoId}})
            this.closeForm();
          })
          .catch((error) => {
            this.sweetAlertLoadingClose()

            const message = error.message || error;
            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
            Toast.fire(this.$t("msg.failed"), message, "error");
          });
    },
  },
};
